import { Component, OnInit } from '@angular/core';

import { OAuthService } from '@app/auth/oauth.service';
import { trackEvent } from '@app/utils/amplitude.utils';

@Component({
    selector: 'app-logout',
    template: '',
    styles: [],
})
export class LogoutComponent implements OnInit {
    constructor(private oauth: OAuthService) {}

    ngOnInit() {
        trackEvent('Auth Logout');
        this.oauth.logout().subscribe();
    }
}
